var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g({staticClass:"adv-image-element"},_vm.$listeners),[(_vm.useCanvas)?_c('canvas',_vm._b({ref:"canvas"},'canvas',_vm.$attrs,false)):_c('img',_vm._b({attrs:{"src":_vm.src}},'img',_vm.$attrs,false))])}
var staticRenderFns = []

export { render, staticRenderFns }